import { Money, type DecimalString } from "@shop-ledger/shared-types";

/**
 * Pure, framework-free purchase-order line math — extracted so it's independently
 * testable with decimal-precision fixtures, matching this app's existing convention
 * (`domain/ledgerBalance.ts`, `domain/aging.ts`) of never doing money/quantity arithmetic
 * inline with `Number()`. Used by `PurchaseOrderDetailPage` to compute how much of a line
 * is left to receive and whether it's fully received.
 */
export function remainingQuantity(quantityOrdered: DecimalString | string, quantityReceived: DecimalString | string): DecimalString {
  const remaining = Money.subtract(quantityOrdered, quantityReceived);
  // Clamp to zero — an over-receipt should never happen (the backend rejects it with a
  // 409 before it's ever persisted), but display code should never show a negative
  // "remaining" even transiently.
  return Money.compare(remaining, "0") < 0 ? Money.zero() : remaining;
}

export function isFullyReceived(quantityOrdered: DecimalString | string, quantityReceived: DecimalString | string): boolean {
  return Money.compare(remainingQuantity(quantityOrdered, quantityReceived), "0") <= 0;
}
